sn-partner-type-1 {
  .sn-partner-type-1 {
    .me-container {
      padding-bottom: px-to-rem(60px);

      @include above(768px) {
        padding-bottom: px-to-rem(82px);
      }

      @include above(960px) {
        padding-bottom: px-to-rem(120px);
      }

      @include above(1200px) {
        padding-bottom: px-to-rem(140px);
      }
    }
  }

  .sn-partner-type-1__row {
    display: block;
    position: relative;
    padding: px-to-rem(28px);
    background: #e9f1ff;
    border-radius: var(--radius-size-lg);

    @include above(768px) {
      padding: px-to-rem(38px);
    }

    @include above(960px) {
      padding: px-to-rem(48px) px-to-rem(310px) px-to-rem(48px) px-to-rem(48px);
    }

    @include above(1200px) {
      padding: px-to-rem(48px) px-to-rem(384px) px-to-rem(48px) px-to-rem(48px);
    }
  }

  .sn-partner-type-1__logo {
    margin-bottom: px-to-rem(20px);

    @include above(960px) {
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      top: px-to-rem(50px);
      right: px-to-rem(50px);
      margin-bottom: 0;
    }

    me-picture,
    img {
      width: px-to-rem(64px);
      height: auto;
      display: block;

      @include above(960px) {
        width: px-to-rem(220px);
      }
    }
  }

  me-heading {
    display: block;

    .me-heading {
      font-weight: 700;
      font-size: px-to-rem(20px);
      line-height: px-to-rem(28px);
      margin-bottom: px-to-rem(16px);
      text-align: left;
      -webkit-font-smoothing: antialiased;

      @include above(768px) {
        font-size: px-to-rem(36px);
        line-height: px-to-rem(48px);
        margin-bottom: px-to-rem(22px);
      }

      @include above(960px) {
        font-size: px-to-rem(40px);
      }
    }
  }

  .sn-partner-type-1__message {
    me-text {
      display: block;

      .me-text,
      p {
        font-size: px-to-rem(14px);
        line-height: px-to-rem(24px);
        margin-bottom: 0;

        @include above(768px) {
          font-size: px-to-rem(16px);
          line-height: px-to-rem(28px);
        }

        &:not(:last-child) {
          margin-bottom: px-to-rem(16px);
        }
      }
    }
  }
}
